import { render } from "./yougou.vue?vue&type=template&id=3a2ccf38&scoped=true"
import script from "./yougou.vue?vue&type=script&lang=js"
export * from "./yougou.vue?vue&type=script&lang=js"

import "./yougou.vue?vue&type=style&index=0&id=3a2ccf38&scoped=true&lang=css"

import exportComponent from "/Users/liusx/Projects/pc-web-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2ccf38"]])

export default __exports__